<div class="errorDialogContainer">
  <h1 mat-dialog-title>{{ data.statusCode }} - {{ data.statusText }}</h1>

  <div mat-dialog-content>
    <p>{{ data.message }}</p>
  </div>
  <div class="actionButtonsContainer" mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="primary" class="okBtn" cdkFocusInitial>
      Ok
    </button>
  </div>
</div>